/**
 * Generates a Sanity image URL with specified width, height,format and quality.
 *
 * @param {string} src - The Sanity image URL.
 * @param {number|string} imageWidth - The desired width of the image in pixels.
 * @param {number|string} imageHeight - The desired height of the image in pixels.
 * @param {number} quality - Optional image quality (1-100), defaults to 90.
 * @returns {string} - The generated image URL with the specified parameters.
 */

interface SanityImageLoaderProps {
  src: string;
  quality?: number;
  imageWidth?: string | number;
  imageHeight?: string | number;
  width?: number;
}

const sanityImageLoader = ({
  src,
  imageWidth,
  imageHeight,
  width,
  quality = 95,
}: SanityImageLoaderProps) => {
  if (!src) return "";
  if (typeof src === "string" && src.toLowerCase().includes(".svg")) {
    return src;
  }
  try {
    const url = new URL(src);
    if (imageHeight) {
      url.searchParams.set("h", imageHeight.toString());
    }
    const targetW = imageWidth
      ? Math.round(Number(imageWidth) * 2)
      : width
      ? Math.round(Number(width) * 2)
      : undefined;

    if (targetW) {
      url.searchParams.set("w", targetW.toString());
    }
    url.searchParams.set("q", quality.toString());
    url.searchParams.set("auto", "format");
    return url.href;
  } catch {
    return src;
  }
};

export default sanityImageLoader;
